export const appSliderLeftIcon = {
    data: `<svg viewBox="0 0 20 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.2109 2.57L17.4309 0.739998L0.790941 17.87L17.4309 35L19.2109 33.17L4.38094 17.87L19.2109 2.57Z" fill="#4F4F4F"/></svg>`,
    name: 'slider-left'
};